import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotActiveinitialInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 14,
			fill: "#EBEBEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1057 13.2473C14.0391 13.2407 13.9591 13.2407 13.8857 13.2473C12.2991 13.194 11.0391 11.894 11.0391 10.294C11.0391 8.66065 12.3591 7.33398 13.9991 7.33398C15.6324 7.33398 16.9591 8.66065 16.9591 10.294C16.9524 11.894 15.6924 13.194 14.1057 13.2473Z",
			stroke: "#A0A0A0",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.7725 15.706C9.15917 16.786 9.15917 18.546 10.7725 19.6193C12.6058 20.846 15.6125 20.846 17.4458 19.6193C19.0592 18.5393 19.0592 16.7793 17.4458 15.706C15.6192 14.486 12.6125 14.486 10.7725 15.706Z",
			stroke: "#A0A0A0",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNotActiveinitialInfo;
